import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@clinic-os/ui';
import { AIDocumentation } from './AIDocumentation';

export function AIDocumentationPage() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-slate-900">AI Clinical Documentation</h1>
        <p className="text-sm text-slate-500 mt-1">
          Transform voice recordings into structured clinical notes and billing codes
        </p>
      </div>
      <AIDocumentation />
    </div>
  );
}
